import { Icon } from "@sellar-io/components";
import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";
import { getUnifiedCheckoutDeliveryDates } from "../getUnifiedCheckoutDeliveryDates";

type UnifiedCheckoutDeliveryDateSummaryProps = {
  deliveryPreference: "consolidated" | "split" | null | undefined;
  consolidatedDeliveryDate: string | Date | null | undefined;
  supplierDeliveryDates: Array<string | Date | null | undefined>;
  className?: string;
  includeYear?: boolean;
};

export const UnifiedCheckoutDeliveryDateSummary = ({
  deliveryPreference,
  consolidatedDeliveryDate,
  supplierDeliveryDates,
  className,
  includeYear = false,
}: UnifiedCheckoutDeliveryDateSummaryProps) => {
  const dates = getUnifiedCheckoutDeliveryDates({
    deliveryPreference,
    consolidatedDeliveryDate,
    supplierDeliveryDates,
  });
  if (dates.length === 0) return null;

  const label = dates.length > 1 ? "Deliveries" : "Delivery";
  const formattedDates = dates
    .map((date) =>
      dayjs(date).format(includeYear ? "ddd D MMM YYYY" : "ddd D MMM"),
    )
    .join(", ");

  return (
    <div className={twMerge("flex items-center gap-2", className)}>
      <Icon icon="SELLAR_DISTRIBUTION_TRUCK" size={0.8} />
      <span className="font-medium">
        {label}: {formattedDates}
      </span>
    </div>
  );
};
